import 'whatwg-fetch'
import 'scss_mixin/reset.scss' //reset 样式
import 'tools/polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from "react-router-dom";

import { pollingAndSendPoint, storageInitConfig } from 'wmda_bx_report';


import App from './containers/App';
import { getRequestParams, sqbSession } from "@sqb/utility";

sqbSession();
pollingAndSendPoint();

storageInitConfig.initConfig({
    defaultParams: () => {
        // 从链接中获取渠道
        const sqbChannel = getRequestParams(window.location.search).sqbChannel;

        // 从链接中获取资源位
        const sqbResource = getRequestParams(window.location.search).sqbResource;

        return {
            sqbResource,
            sqbChannel
        };
    }
});

ReactDOM.render(
    <React.Suspense fallback={<div></div>}>
        <Router basename="/agentapp/activity">
            <App />
        </Router>
    </React.Suspense>,

    document.getElementById('root')
);
